import { Plus, Search } from "lucide-react"

import {
  Button,
  DataTableCustomize,
  DataTableFilterChips,
  DataTableFilters,
  Input,
  type DataTableInstance,
} from "@atlant/ui"

import { AircraftGeneralInfoModal } from "../add-aircraft.tsx"
import { fleetFilters } from "../table/fleet-columns.tsx"
import type { FleetRow } from "../table/fleet-table-types.ts"
import { useFleetFilterStore } from "./fleet-filter-store.ts"
import { FleetScopeSelect } from "./fleet-scope-select.tsx"
import { FleetViewToggle } from "./fleet-view-toggle.tsx"
import { useFleetViewStore } from "./use-fleet-view-store.ts"

export const FleetToolbar = ({ table }: { table: DataTableInstance<FleetRow> }) => {
  const { scope, setScope } = useFleetFilterStore()
  const { view } = useFleetViewStore()

  return (
    <div className="space-y-3 py-3">
      <div className="flex items-center justify-between gap-2">
        <FleetScopeSelect value={scope} onChange={setScope} />
        <div className="flex items-center gap-2">
          <div className="relative">
            <Search className="text-muted-foreground absolute top-1/2 left-2.5 size-4 -translate-y-1/2" />
            <Input
              value={(table.state.globalFilter as string | undefined) ?? ""}
              onChange={(e) => table.setGlobalFilter(e.target.value)}
              placeholder="Search fleet..."
              className="h-8 w-56 pl-8"
            />
          </div>
          <DataTableFilters table={table} filters={fleetFilters} />
          {view === "list" && <DataTableCustomize table={table} />}
          <FleetViewToggle />
          <AircraftGeneralInfoModal
            trigger={
              <Button size="sm" className="gap-1.5">
                <Plus className="size-4" />
                Add Fleet
              </Button>
            }
          />
        </div>
      </div>
      <DataTableFilterChips table={table} filters={fleetFilters} />
    </div>
  )
}
